export const API_URL =
  process.env.REACT_APP_API_URL || "https://twizzcheats.store/api";
export const STATIC_URL =
  process.env.REACT_APP_STATIC_URL || "https://twizzcheats.store";
